import { RateLimitedAction } from '@hh.ru/magritte-common-func-utils/types';

export const debounce: RateLimitedAction = (callback, waitMS) => {
    let timeoutId: null | ReturnType<typeof setTimeout> = null;

    const debounced = function (this: unknown, ...args: Parameters<typeof callback>) {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }

        timeoutId = setTimeout(() => {
            callback?.apply(this, args);
        }, waitMS);
    };

    debounced.cancel = () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
            timeoutId = null;
        }
    };

    return debounced;
};
